import { ApplicationState } from 'application/redux'
import { close as closeModal, open as openModal } from 'core/modal/redux/actions'
import { runCommands } from 'modules/operational/device/detail/_settings/redux/actions'
import { clearConfigManagementData, deleteConfigManagementFile, downloadConfigManagementFile, getConfigManagementData, invalidFileUploadToaster, uploadFile } from 'modules/operational/rtf/redux/configManagement/actions'
import { clearConfigManagementUploadLogs, getConfigManagementUploadLogs } from 'modules/operational/rtf/redux/logs/configManagement/actions'
import { connect } from 'react-redux'
import { cancelCommand, clearActivityLogState, getActivityLog } from '../../../redux/logs/activity/actions'
import { clearDownloadURL, getDownloadURL, getHistory } from '../../../redux/logs/history/actions'
import { executeCommand } from '../../../redux/settings/actions'
import ContentComponent from './Component'

const mapStateToProps = (state: ApplicationState) => ({
  device: state.rtf.rtfDevices.current,
  history: state.rtf.rtfLogs.history,
  activity: state.rtf.rtfLogs.activity,
  configManagement: state.rtf.rtfConfigurationManagement,
  configManagementLogs: state.rtf.rtfLogs.configManagement
})

export default connect(mapStateToProps, {
  openModal,
  closeModal,
  executeCommand,
  runCommands,
  getHistory,
  getDownloadURL,
  clearDownloadURL,
  getActivityLog,
  cancelCommand,
  clearActivityLogState,
  getConfigManagementData,
  clearConfigManagementData,
  downloadConfigManagementFile,
  deleteConfigManagementFile,
  invalidFileUploadToaster,
  uploadFile,
  getConfigManagementUploadLogs,
  clearConfigManagementUploadLogs,
})(ContentComponent)
